import routes from '../routes/adminRoutes'
import SignIn from '../views/admin/SignIn'
import Subscribers from '../views/admin/Subscribers'
import SubscriberCreate from '../views/admin/SubscriberCreate'
import SubscriberEdit from '../views/admin/SubscriberEdit'
import Sites from '../views/admin/Sites'
import SiteCreate from '../views/admin/SiteCreate'
import SiteEdit from '../views/admin/SiteEdit'
import Users from '../views/admin/Users'
import UserCreate from '../views/admin/UserCreate'
import UserEdit from '../views/admin/UserEdit'
import Trials from '../views/admin/Trials'
import Metas from '../views/admin/Metas'
import MetaCreate from '../views/admin/MetaCreate'
import MetaEdit from '../views/admin/MetaEdit'

export default {
  signIn: { path: routes.signIn, view: SignIn },
  subscribers: { path: routes.subscribers, view: Subscribers },
  subscriberCreate: { path: routes.subscriberCreate, view: SubscriberCreate },
  subscriberEdit: { path: routes.subscriberEdit, view: SubscriberEdit },
  sites: { path: routes.sites, view: Sites },
  siteCreate: { path: routes.siteCreate, view: SiteCreate },
  siteEdit: { path: routes.siteEdit, view: SiteEdit },
  users: { path: routes.users, view: Users },
  userCreate: { path: routes.userCreate, view: UserCreate },
  userEdit: { path: routes.userEdit, view: UserEdit },
  trials: { path: routes.trials, view: Trials },
  metas: { path: routes.metas, view: Metas },
  metaCreate: { path: routes.metaCreate, view: MetaCreate },
  metaEdit: { path: routes.metaEdit, view: MetaEdit }
}
